<ng-container class="banner-skeleton" *ngIf="loading; else content">
  <nz-skeleton
    [nzLoading]="loading"
    [nzParagraph]="{ rows: 1 }"
    [nzActive]="true"
    [nzAvatar]="true"
  ></nz-skeleton>
</ng-container>

<ng-template #content>
  <div *ngIf="showBanner && bannerType" class="box-payment flex">
    <div
      class="rectangle-payment flex align_center gap-4"
      [ngClass]="{
        flex_sb: subscriptionDetails?.canDismiss
      }"
    >
      <div class="image-payment">
        <img [src]="images.SUBSCRIPTION_FRAME" alt="subscription" />
      </div>
      <div class="center-text-wrapper">
        <div *ngIf="subscriptionDetails?.isPaymentOverdue && subscriptionDetails?.currentPaymentPendingAmount" class="payment-due-info">
          <div class="fw-700 fs-16 mb-2">{{ 'YOUR_PAYMENT_IS_DUE' | fallbackTranslate }}</div>
          <div class="fw-600 fs-14 mb-2">
            Amount due: {{ getCurrencySymbol() }} {{ subscriptionDetails?.currentPaymentPendingAmount }}
          </div>
        </div>
        <div class="text-payment" [innerHTML]="formattedString"></div>
        <a (click)="renew()" class="renewal-link m-l-5 fw-700 fs-14">
          {{ 'RENEW_NOW' | fallbackTranslate }}
        </a>
      </div>

      <div
        *ngIf="subscriptionDetails?.canDismiss"
        (click)="dismissBanner()"
        class="cross c-pointer"
      >
        <img [src]="images.CLOSE" class="close-icon" alt="close" />
      </div>
    </div>
  </div>
</ng-template>
